module.exports = __webpack_public_path__ + "static/media/8779.1173d53d.png";